module.exports = __webpack_public_path__ + "img/to.f32ba8af.svg";